// en-US is an override-only layer: it holds ONLY the keys whose American
// spelling differs from en-GB (theatre/theater, finalise/finalize). Everything
// else resolves through the en-US -> en-GB fallback declared in ../../config.js,
// so unchanged copy is never duplicated. Same approach as the legacy PHP app's
// translations/en-US/spelling.php.
import events from "./events.json"
import meta from "./meta.json"

export default { meta, events }
